module.exports = __webpack_public_path__ + "static/media/servicios_comercializacion_1.ad0aac87.png";